import {
  CButton,
  CCol,
  CFormInput,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react';
import React, {useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Table.module.css';
import { AppContext } from '../../context/AppContext';
import TableCaption from './TableCaption';
import TableFooter from './TableFooter';
import { PUBLIC_URL } from '../../constants';




const Table = ({ columns, data, pagination }) => {

  const {setSponsorsPageUrl} = useContext(AppContext);

  //Navigation
  const navigate = useNavigate();

  //Methods
  const handleAction = (id) => {
    
  }

  return (
    <>
      {/* <CCol className="mt-4 mb-5">
        <CFormInput
          type="search"
          placeholder="Buscar por Nº de pedido"
          style={{ width: '100%' }}
        />
      </CCol>
      <CCol className="mt-4 mb-5">
        <CFormInput
          type="search"
          placeholder="Buscar por nombre o apellido"
          style={{ width: '100%' }}
        />
      </CCol> */}

        <div className="col-12">
        <TableCaption pagination={pagination} noun="auspiciantes" />
        <div className={styles.tableCard}>
        <CTable responsive className={styles.styledTable}>
          <CTableHead>
            <CTableRow>
              {columns.map((col, index) => (
                col.key == "actions" ?
                <CTableHeaderCell key={index} scope="col" style={{textAlign:'end'}}>
                  {col.label}
                </CTableHeaderCell> :
                <CTableHeaderCell key={index} scope="col">
                {col.label}
              </CTableHeaderCell> 
              ))}
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {data?.map((sponsor, index) => (
              <CTableRow key={index}>
                <CTableDataCell>{sponsor.id}</CTableDataCell>
                <CTableDataCell>
                  <img src={`${PUBLIC_URL}${sponsor.logo.path}`} className={styles.img} alt="img"/>
                </CTableDataCell>
                <CTableDataCell>{sponsor.name}</CTableDataCell>
                <CTableDataCell style={{textAlign:'end'}}>
                  <CButton 
                    className={`${styles.rowActionButton}`} 
                    style={{width:"max-content"}}
                    onClick={() => navigate(`/dashboard/sponsors/${sponsor?.id}`)}
                  >
                    Editar
                  </CButton>
                </CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
        {!data || data.length === 0 ? (
          <div className={styles.emptyState}>No se encontraron resultados.</div>
        ) : null}
        </div>
        </div>
        <TableFooter range={pagination?.links} setPageUrl={setSponsorsPageUrl} />
    </>
  );
};

export default Table;
